// extracted by mini-css-extract-plugin
export default {"aliases":"styles_aliases__TKE4N","name":"styles_name__gEN+B","inn":"styles_inn__NX0Qj","tabToTop":"styles_tabToTop__xthZM"};